import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 2em 0;

    .headline {
        font-size: 1.1em;
        font-weight: 700;
    }

    .location {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        gap: 1.5em;
        margin-top: 1em;

        .address {
            text-transform: capitalize;
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        font-size: 120%;

        .location {
            flex-direction: column;
            align-items: flex-start;
        }
    }
`;
